const AgregarFamiliar = ({listaFamiliares, familiaresSeleccionados, setGrupoFamiliar, afiliado, titularSeleccionado, setTitularSeleccionado}) => {

    // Crear array con titular primero, luego familiares
    const grupoCompleto = afiliado ? [
        { dni: afiliado.dni, apellido: afiliado.apellido, nombre: afiliado.nombre, esTitular: true },
        ...listaFamiliares
    ] : listaFamiliares;

    return (
        <>
            <div className="mb-2 mt-3 ms-1 text-muted">¿Quiénes asistiran del grupo familiar?</div>
            {
                grupoCompleto.map((persona) => {
                    const esTitular = persona.esTitular;
                    // Normalizar DNI a string para comparación
                    const dniPersona = String(persona.dni);
                    const estaSeleccionado = esTitular 
                        ? titularSeleccionado 
                        : familiaresSeleccionados.some(dni => String(dni) === dniPersona);

                    return <div
                        key={persona.dni} 
                        className="ps-2"  
                    >
                        <input
                            type="checkbox"
                            id={"chk" + persona.dni}
                            name={dniPersona}
                            checked={estaSeleccionado}
                            onChange={e => {
                                if(esTitular) {
                                    // Manejar check del titular
                                    setTitularSeleccionado(e.target.checked);
                                } else {
                                    // Manejar check de familiares
                                    const dniFamiliar = e.target.name; // Ya es string
                                    setGrupoFamiliar(stateAnterior => {
                                        if(e.target.checked){
                                            // Verificar que no esté ya agregado
                                            if(!stateAnterior.some(dni => String(dni) === dniFamiliar)){
                                                return [...stateAnterior, dniFamiliar];
                                            }
                                            return stateAnterior;
                                        } else {
                                            return stateAnterior.filter(dni => String(dni) !== dniFamiliar);
                                        }
                                    });
                                }
                            }}
                            value={false}
                        />
                        <label
                            htmlFor={"chk" + persona.dni}
                            className="ps-2"
                        >
                            {persona.apellido + ", " + persona.nombre}
                            {esTitular && <span className="text-muted ms-2">(Titular)</span>}
                        </label>
                    </div>
                })
            }
        </>
    )
}

export default AgregarFamiliar
